module.exports = __webpack_public_path__ + "static/media/close-icon-gray.7c8bfc95.svg";